import { Button, MenuItem, Select, TextField } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import React, { useEffect, useState, useRef } from 'react';
import toast from 'react-hot-toast';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useHistory, useLocation } from "react-router-dom";
import http from "../services/httpService";
import handleValidation from '../utils/handleValidations';
import handleSubmitValidation from '../utils/handleSubmitValidation';
const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        paddingTop: theme.spacing(2),
        textAlign: 'left',
        color: theme.palette.text.primary,
    },
    submitButton: {
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(10),


    },
    gridDevider: {
        marginTop: theme.spacing(6),
        textAlign: 'left',
        color: theme.palette.text.primary,
    },
    lableColor: {
        color: "#393939"
    },
    select: {
        height: 36,
        minWidth: 235,

    },
    mobileCode: {
        height: 36,
    },
    radio: {
        '&$checked': {
            color: '#57bf74'
        }
    },
    reviewButton: {
        borderRadius: "20px",
        border: "1px solid #2835D5",
        opacity: 1,
        textAlign: "right"
    },

    checked: {}

}));



function EditCMS() {
    let history = useHistory();
    let form = {
        'title': "",
        'author': "",
        'content': "",
        'tags': "",
        'image': "",
        'assettype': 1,
        'archived': false,
        'url': ""
    }
    const location = useLocation();
    const myparams = location.state;
    const classes = useStyles();
    const [formObject, setFromObject] = useState(form);
    const [questionner, setQuestionner] = useState([]);
    let [lookupFile, setLookupFile] = useState(null);
    const [image, setImage] = useState(null);
    const fileInputRef = useRef(null)
    const formats = [
        "header",
        "font",
        "size",
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "list",
        "bullet",
        "indent",
        "link",
        "image",
        "color"
    ]
    const columns = [
        { "value": 'title', label: 'Title', minWidth: 170, "filedType": "text" },
        { "value": 'author', label: 'Author', minWidth: 150, "filedType": "text" },
        { "label": "Category", "filedType": "dropDown", "value": "assettype" },
        { "value": 'image', label: 'Picture', minWidth: 150, "filedType": "file" },
        { "value": 'content', label: 'Content', minWidth: 150, "filedType": "textarea", multiline: true, rows: 10 },
        { "value": 'tags', label: 'Tags', minWidth: 150, "filedType": "text" },
        { "value": 'url', label: 'URL', minWidth: 150, "filedType": "text" },

    ];
    const validations = {
        "title": {
            conditions: {
                "required": true, "maxLength": 500
            }, "message": "This Field is required!", "valid": true, "changed": false
        },
        "author": {
            conditions: {
                "required": true, "maxLength": 100
            }, "message": "Maximum 20 character Allowed.!", "valid": true, "changed": false
        },
        "content": {
            conditions: {
                "required": true, "maxLength": 10000, "delimiter": " "
            }, "message": "Maximum 1000 character Allowed.!", "valid": true, "changed": false
        },
        "assettype": {
            conditions: {
                "required": true
            }, "message": "Maximum 1000 character Allowed.!", "valid": true, "changed": false
        }, "tags": {
            conditions: {
                "required": false, "maxLength": 500, "delimiter": " "
            }, "message": "Maximum 1000 character Allowed.!", "valid": true, "changed": false
        },

    }
    const [validationState, setValidationState] = useState(validations)
    const getCountryDropdownValue = (field, text, qarray) => {
        if (text) {
            let CurrentQuestion = columns.filter(obj => {
                return obj['value'] === field;
            })
            let current = []
            if (CurrentQuestion && CurrentQuestion.length > 0) {
                current = qarray.filter(obj => {
                    return obj['question'] === "Asset Classes"
                })
            }

            if (current && current.length > 0) {
                let value = current[0].options.filter(option => {
                    return option['name'] === text
                })
                if (value.length > 0) {
                    return value[0]['values']
                } else {
                    return "";
                }


            } else {
                return "";
            }

        } else {
            return "";
        }
    }
    const handleCancel = () => {
        if (myparams && myparams.id) {

            http.get("/categorydropdown").then((response) => {
                if (response.data && response.data.Data && Array.isArray(response.data.Data) && response.data.Data.length > 0) {
                    setQuestionner(response.data.Data)
                    let updatedForm = {
                        'title': myparams.title,
                        'author': myparams.author,
                        'content': "",
                        'tags': myparams.tags,
                        'image': null,
                        'assettype': getCountryDropdownValue("assettype", myparams.assettype, response.data.Data),
                        'archived': myparams.archived,
                        'url': myparams.url || ""
                    }
                    if (myparams.image) {
                        setImage(myparams.image);
                    }
                    setFromObject(updatedForm)
                    setFromObject({
                        ...formObject,
                        content: myparams.content
                    });
                }
                else {
                    // toast.error("Questioner Data Not Available for this investor..!")
                    history.goBack();
                }

            }).catch((error) => {
                // toast.error("Questioner Data Not Available for this investor..!")
                history.goBack();
            })
        } else {
            toast.error("Content Data not Available!")

        }


    }

    const handleFileChange = (event) => {
        setLookupFile(event.target.files[0])

    }
    useEffect(() => {
        handleCancel()
    }, [])
    const handleChange = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        let valid = true;
        let validStateTemp = { ...validationState }
        if (name && validStateTemp.hasOwnProperty(name)) {
            let validation = handleValidation(name, value, validStateTemp);

            setValidationState(validation.validStateTemp)
            valid = validation.valid
        }
        // (value, valid)
        if (valid || value === "" || value == 0) {
            setFromObject({
                ...formObject,
                [event.target.name]: event.target.value
            });
        }
    }
    const checkValidation = () => {
        let name = "content";
        let value = formObject.content;
        let valid = true;
        let validStateTemp = { ...validationState }
        if (name && validStateTemp.hasOwnProperty(name)) {
            let validation = handleValidation(name, value, validStateTemp);

            setValidationState(validation.validStateTemp)
            valid = validation.valid
        }
    }
    const handleTextChangeChange = (value) => {
        setFromObject({
            ...formObject,
            "content": value
        });
    }
    const handleSubmit = (event) => {
        let validStateTemp = { ...validationState }
        let validCount = 0;
        let finalObjet = { ...formObject };

        let validData = handleSubmitValidation(finalObjet, validStateTemp)
        validCount = validData.validCount;
        if (validCount === 0) {
            columns.map(obj => {
                let filter = []
                if (obj["filedType"] == "dropDown") {
                    filter = questionner.filter(question => {
                        return question.question === "Asset Classes"
                    })
                    if (filter.length > 0) {
                        let value = filter[0].options.filter(option => {
                            return option.values === finalObjet[obj.value]
                        })

                        if (value.length > 0) {
                            finalObjet[obj.value] = value[0]['name']
                        }
                    }

                }

            })
            const formData = new FormData();
            formData.append("title", finalObjet["title"]);
            formData.append("author", finalObjet["author"]);
            formData.append("assettype", finalObjet["assettype"]);
            formData.append("content", finalObjet["content"]);
            formData.append("tags", finalObjet["tags"]);
            formData.append("archived", finalObjet['archived']);
            formData.append("url", finalObjet['url']);

            if (lookupFile) {
                formData.append("image", lookupFile, lookupFile["name"]);
            }
            http.put("/updatearchivedcontent/" + myparams.id + "/", formData,
            ).then((response) => {
                if (response && response.data && response.data.id) {
                    toast.success("Contenten Updated Successfully")
                    history.goBack();
                } else {
                    toast.error("Contenten Updated failed..!")
                }

                // setFromObject(form)
            }).catch((error) => {
                toast.error("Contenten Updated failed..!")
            })
        }
        else {
            setValidationState(validData.validStateTemp);
            toast.error("Please check Errors in Field level!")
        }
    }
    return (
        <Grid container component="main" >

            <Grid item xs={12} sm={5} md={5} className="pb30">
                <Button variant="outlined" color="default" startIcon={<ArrowBackIosIcon />} onClick={history.goBack}>Back</Button>
            </Grid>
            <Grid item xs={12} sm={5} md={5} className="overviewbar">
                <Typography color="textPrimary" variant="h5" >View / Edit Post</Typography>
            </Grid>
            <Grid container style={{ marginTop: 50 }}>
                {
                    columns.map((question, inx) => {
                        return (
                            <Grid container className={classes.paper} key={inx + "cms"}>
                                <Grid item xs={12} sm={2} md={2} className={"formLable"}>
                                    <InputLabel className={classes.lableColor} id={question.lable}>{question.label}</InputLabel>
                                </Grid>
                                <Grid item xs={12} lg={4} md={4} sm={4}>{question.filedType === "text" ?
                                    <TextField label="Enter" variant="outlined" value={formObject[question.value]} name={question.value} onChange={handleChange} className={'input'}
                                        style={validationState.hasOwnProperty(question.value) && validationState[question.value]['changed'] && !validationState[question.value]['valid'] ? { paddingBottom: 20 } : {}}
                                        error={validationState.hasOwnProperty(question.value) && validationState[question.value]['changed'] && !validationState[question.value]['valid']}
                                        helperText={validationState.hasOwnProperty(question.value) && validationState[question.value]['changed'] && !validationState[question.value]['valid'] ? validationState[question.value]['message'] : ""}
                                    /> :
                                    (question.filedType === "textarea") ? <> <div style={{ height: 200 }}>
                                        <ReactQuill value={formObject[question.value]}
                                            onChange={handleTextChangeChange} onBlur={checkValidation} name={question.value} style={{ width: 500, height: 150 }} formats={formats} theme={"snow"} />

                                    </div>
                                        {validationState.hasOwnProperty(question.value)
                                            && validationState[question.value]['changed'] &&
                                            !validationState[question.value]['valid'] ?
                                            <div style={{ color: "#f44336", fontSize: "0.75rem", margin: "3px 14px" }}>{validationState[question.value]['message']}</div> : null}
                                    </>
                                        : question.filedType === "dropDown" ? (
                                            questionner.filter(obj => { return obj.question === "Asset Classes" }).map(a => {
                                                return (<><Select displayEmpty labelId={question.lable + "label"} id="statusSelect" variant="outlined" className={'input'} onChange={handleChange} value={(formObject[question.value]) ? formObject[question.value] : ""} name={question.value} key={"aasettypekey"}
                                                    style={validationState.hasOwnProperty(question.value) && validationState[question.value]['changed'] && !validationState[question.value]['valid'] ? { paddingBottom: 20 } : {}}
                                                    error={validationState.hasOwnProperty(question.value) && validationState[question.value]['changed'] && !validationState[question.value]['valid']}
                                                >
                                                    <MenuItem value="">Select</MenuItem>
                                                    {a.options.map(option => {
                                                        return <MenuItem value={option.values} key={option.values + "cmsdd"}>{option.name}</MenuItem>
                                                    })}
                                                    )
                                                </Select>
                                                    {validationState.hasOwnProperty(question.value)
                                                        && validationState[question.value]['changed'] &&
                                                        !validationState[question.value]['valid'] ?
                                                        <div style={{ color: "#f44336", fontSize: "0.75rem", margin: "3px 14px" }}>{validationState[question.value]['message']}</div> : null}
                                                </>)
                                            })
                                        ) : question.filedType === "file" ?
                                            <> <input
                                                ref={fileInputRef}
                                                onChange={handleFileChange}
                                                type="file"
                                                style={{ display: "none" }}
                                                multiple={false}
                                                accept=".png,.PNG,.JPEG,.jpeg,.jpg,.JPG"
                                            />
                                                <Button startIcon={<AddCircleOutlineIcon />} variant="outlined" className={classes.reviewButton} color="primary" onClick={() => fileInputRef.current.click()}>Choose File</Button>
                                                <span style={{ marginLeft: 10 }}>{lookupFile && lookupFile.name ? lookupFile.name : "No file chosen"}</span></> : ""}
                                </Grid>
                            </Grid>
                        )
                    })
                }
            </Grid>
            <Grid container className={classes.submitButton, "pb30", "mt30"}>
                <Grid item xs={12} sm={2} md={2} className="addBtn">

                </Grid>
                <Grid item xs={12} sm={1} md={1} >
                    <Button variant="outlined" color="default" onClick={handleCancel} className="addBtn">Cancel</Button>
                </Grid>

                <Grid item xs={12} sm={2} md={2} >
                    <Button variant="contained" color="primary" onClick={handleSubmit} className="addBtn">Update</Button>
                </Grid>
            </Grid>
        </Grid>
    )

}


export default EditCMS;